import React, { Component } from 'react'
import { Segment, Dropdown } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { populateStreets } from '../../store/Actions'
import {
  updateSignsCache,
  updateOrdersCache,
} from '../../store/Actions/SignsActions'
import { filterStreetsValue } from '../../store/Actions/UiActions'
import Orders from './Orders'
import './styles/List.css'

class List extends Component {
  filterStreets = (e, data, streetType) => {
    this.props.filterStreetsValue(data.value)
    if (data.value.length === 0) {
      this.props.updateSignsCache({ signs: this.props.signs })
      this.props.updateOrdersCache(this.props.orders)
      this.props.populateStreets(this.props.signs)
      return
    }

    let filteredSigns = this.props.signs.filter(sign =>
      data.value.every(r =>
        [
          sign.properties.on_street,
          sign.properties.from_street,
          sign.properties.to_street,
        ].includes(r)
      )
    )
    let filteredOrders = this.props.orders.filter(order =>
      data.value.every(r =>
        [
          order.properties.on_street,
          order.properties.from_street,
          order.properties.to_street,
        ].includes(r)
      )
    )
    this.props.populateStreets(filteredSigns)
    this.props.updateSignsCache({ signs: filteredSigns })
    this.props.updateOrdersCache(filteredOrders)
  }

  componentWillUnmount = () => {
    this.props.populateStreets(this.props.signs)
  }

  render() {
    return (
      <div id="list-view">
        <Segment color="blue">
          <Dropdown
            placeholder="Filter streets.."
            search
            multiple
            selection
            fluid
            closeOnChange
            options={this.props.streets}
            onChange={(e, data) => this.filterStreets(e, data)}
            value={this.props.filterStreets}
          />
        </Segment>
        <Orders />
      </div>
    )
  }
}

const mapDispatchToProps = {
  updateSignsCache,
  updateOrdersCache,
  filterStreetsValue,
  populateStreets,
}

const mapStateToProps = ({ signsState, ui }) => ({
  streets: signsState.streets,
  signsCache: signsState.cache.signs,
  ordersCache: signsState.cache.orders,
  orders: signsState.orders,
  signs: signsState.signs,
  filterStreets: ui.filterStreetsValue,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(List)



// WEBPACK FOOTER //
// ./src/components/List/index.jsx